"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.Widget = void 0;
var jquery_1 = __importDefault(require("jquery"));
var EventBus_1 = require("./EventBus");
var eventBus = new EventBus_1.EventBus();
var Widget = (function () {
    function Widget(element, config) {
        this.tag = "div";
        var Class = this.constructor;
        Class.instances = Class.instances || [];
        Class.instances.push(this);
        this.el = element ? (0, jquery_1.default)(element) : (0, jquery_1.default)(document.createElement(this.tag));
        this.config = jquery_1.default.extend({}, this.defaultConfig(), Class.getDataConfig(this.el, this.dataConfig()), config);
        Widget.setupBusBindings(this, this.config.busBindings);
        this.init();
    }
    Widget.prototype.defaultConfig = function () { return {}; };
    Widget.prototype.dataConfig = function () { return []; };
    ;
    Widget.prototype.init = function () { };
    Widget.getBus = function () {
        return eventBus;
    };
    Widget.each = function (selector, config, context) {
        var Class = this;
        (0, jquery_1.default)(selector, context).each(function (_, node) {
            if (Class.isImplemented(node) === false) {
                return new Class(node, config);
            }
            return null;
        });
    };
    Widget.isImplemented = function (node) {
        var instances = this.instances || [];
        for (var _i = 0, instances_1 = instances; _i < instances_1.length; _i++) {
            var widget = instances_1[_i];
            if ('el' in widget && widget.el.is(node)) {
                return true;
            }
        }
        return false;
    };
    Widget.getDataConfig = function (element, fields) {
        if (fields === void 0) { fields = []; }
        var config = {};
        for (var _i = 0, fields_1 = fields; _i < fields_1.length; _i++) {
            var fieldName = fields_1[_i];
            var fieldValue = element.attr('data-' + fieldName);
            if (fieldValue !== null) {
                config[fieldName] = fieldValue;
            }
        }
        return config;
    };
    Widget.setupBusBindings = function (widget, bindings) {
        if (!bindings) {
            return;
        }
        var bus = Widget.getBus();
        var method, list, event;
        for (method in bindings) {
            if (!bindings.hasOwnProperty(method)
                || !(method in widget)
                || typeof widget[method] != 'function') {
                continue;
            }
            list = [].concat(bindings[method]);
            while (list.length) {
                event = list.pop();
                bus.listen(event, jquery_1.default.proxy(widget[method], widget));
            }
        }
    };
    return Widget;
}());
exports.Widget = Widget;
